<template>
		<div class="route-body">
			<div class="fx-header">
				<p>线路管理</p>
			</div>
			<Search @getTableData="getTableDataHandle" @getParamsData="getParamsData"></Search>
			<div class="btn-route-box">
				<el-button
					type="primary"
					class="search-btn fx-big-btn"
					size="small "
					v-if="AuthorityList['01_0007_0003_00']"
					@click='addClick'
					plain>新建
				</el-button>
				<el-button
					type="primary"
					class="search-btn fx-big-btn"
					v-if="AuthorityList['01_0007_0004_00']"
					size="small "
					@click="deleteList"
					plain>删除
				</el-button>
			</div>
			<div class="main-table-box">
				<el-table
				:stripe='true'
				size='mini'
				class="grid-content"
				@row-dblclick='rowClick'
				:data="tableData"
				:height="tableHeight"
				border
				ref='table'
				@select="handleSelectionChange"
				@select-all="handleSelectionChange">
				<el-table-column
				type="selection"
				align="center"
				width="50">
				</el-table-column>
				<el-table-column
					label-class-name = "column-index"
					label="序号"
					type="index"
					width="50"
					align="center">
				</el-table-column>
				<el-table-column
					prop="linecode"
					label="线路编号"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					prop="linename"
					label="线路名称"
					align="center"
					min-width="100">
				</el-table-column>
				<el-table-column
					prop="platenumber"
					label="车牌号"
					align="center"
					min-width="130">
				</el-table-column>
				<el-table-column
					prop="carmodel"
					label="车辆类型"
					align="center"
					min-width="90">
				</el-table-column>
				<el-table-column
					prop="carload"
					label="载重"
					align="center"
					min-width="100">
				</el-table-column>
				<el-table-column
					prop="driver"
					label="司机"
					align="center"
					min-width="90">
				</el-table-column>
				<el-table-column label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button v-if="AuthorityList['01_0007_0002_00'] || AuthorityList['01_0007_0001_00']" @click="modifyClick(scope.row)" type='text' size="mini"
						icon="el-icon-search">编辑</el-button>
						<el-button v-if="AuthorityList['01_0007_0004_00']" @click="deleteClick(scope.row)" type='text' size="mini" icon="el-icon-delete">删除</el-button>
					</template>
				</el-table-column>
				</el-table>
			</div>
        <el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="page.number"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="page.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
		</el-pagination>
		<el-dialog title="线路管理" class="dialog-title" :visible.sync="addModal" width='650px' :close-on-click-modal="false">
			<el-form :model="ruleForm" v-if='addModal' :rules="rules" :inline-message='true' ref="ruleForm" label-position='right' label-width="114px" class="box">
				<el-form-item label="线路编号:" prop='linecode'>
					<el-input class='input-box' size='mini' @change='linecodeChange' v-model="ruleForm.linecode" :maxlength='100'></el-input>
				</el-form-item>
				<el-form-item label="线路名称:" prop='linename'>
					<el-input class='input-box' size='mini' @change='linenameChange' v-model="ruleForm.linename" :maxlength='100'></el-input>
				</el-form-item>
				<el-form-item class='no-star' label="车牌号:" prop='platenumber'>
					<el-input class='input-box' size='mini' @change='platenumberChange' v-model="ruleForm.platenumber" :maxlength='20'></el-input>
				</el-form-item>
				<el-form-item class='no-star' label="车辆类型:" prop='carmodel'>
					<el-input class='input-box' size='mini' @change='carmodelChange' v-model="ruleForm.carmodel" :maxlengsth='20'></el-input>
				</el-form-item>
				<el-form-item class='no-star' label="载重:" prop='carload'>
					<el-input class='input-box' size='mini' @change='carloadChange' v-model="ruleForm.carload" :maxlength='20'></el-input>
				</el-form-item>
				<el-form-item class='no-star' label="司机:" prop='driver'>
					<el-input class='input-box' size='mini' @change='driverChange'  v-model="ruleForm.driver" :maxlength='20'></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" v-if="AuthorityList['01_0007_0002_00'] || AuthorityList['01_0007_0003_00']" class="dialog-footer">
				<el-button size="medium" type="primary" plain @click="cancelClick">取 消</el-button>
				<el-button size="medium" type="primary" plain @click="submitForm('ruleForm')">保 存</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import Search from '@/components/route/Search.vue'
export default {
	name: 'route',
	components: {
		Search
	},
	data () {
		var test1 = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入线路编号'))
			}
			if (/[\u4E00-\u9FA5]/g.test(value)) {
				callback(new Error('支持100个字符内的字母数字，请检查后重新输入！'))
			} else {
				callback()
			}
		}
		var test2 = (rule, value, callback) => {
			if (value === '') {
				callback()
			}
			var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/
			if (!(reg.test(value))) {
				return callback(new Error('支持20个字符内的中文字母数字，请检查后重新输入！'))
			} else {
				callback()
			}
		}
		return {
			ruleForm: {
				lineid: '',
				linecode: '',
				linename: '',
				platenumber: '',
				carmodel: '',
				carload: '',
				driver: ''
			},
			rules: {
				linecode: [
					{ required: true, validator: test1, trigger: 'blur' }
				],
				linename: [
					{ required: true, message: '请输入线路名称', trigger: 'blur' }
				],
				platenumber: [
					{ required: true, validator: test2, trigger: 'blur' }
				],
				carmodel: [
					{ required: true, validator: test2, trigger: 'blur' }
				],
				carload: [
					{ required: true, validator: test2, trigger: 'blur' }
				],
				driver: [
					{ required: true, validator: test2, trigger: 'blur' }
				]
			},
			linecode: '',
			linename: '',
			platenumber: '',
			AuthorityList: {
				'01_0007_0001_00': false,
				'01_0007_0002_00': false,
				'01_0007_0003_00': false,
				'01_0007_0004_00': false
			},
			addModal: false,
			modifyData: {},
			tableData: [],
			tableHeight: '100%',
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'lineid',
				selectHandler: this.tableSelectUtilsHandler
			})
		}
	},
	created () {
		this.tableReload()
		this.getAuthority('01_0007_0000_00')
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
		},
		tableSelectUtilsHandler (row) {
			return {
				lineid: row.lineid
			}
		},
		driverChange () {
			this.ruleForm.driver = this.ruleForm.driver.trim()
			this.ruleForm.driver = this.ruleForm.driver.replace(/[',\\]/g, '')
		},
		carloadChange () {
			this.ruleForm.carload = this.ruleForm.carload.trim()
			this.ruleForm.carload = this.ruleForm.carload.replace(/[',\\]/g, '')
		},
		carmodelChange () {
			this.ruleForm.carmodel = this.ruleForm.carmodel.trim()
			this.ruleForm.carmodel = this.ruleForm.carmodel.replace(/[',\\]/g, '')
		},
		platenumberChange () {
			this.ruleForm.platenumber = this.ruleForm.platenumber.trim()
			this.ruleForm.platenumber = this.ruleForm.platenumber.replace(/[',\\]/g, '')
		},
		linecodeChange () {
			this.ruleForm.linecode = this.ruleForm.linecode.trim()
			this.ruleForm.linecode = this.ruleForm.linecode.replace(/[',\\]/g, '')
		},
		linenameChange () {
			this.ruleForm.linename = this.ruleForm.linename.trim()
			this.ruleForm.linename = this.ruleForm.linename.replace(/[',\\]/g, '')
		},
		cancelClick () {
			this.addModal = false
		},
		submitForm (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.saveClick()
				}
			})
		},
		saveClick () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/line/addOrUpdate`,
				data: this.ruleForm
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功')
					this.addModal = false
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		rowClick (row, column, event) {
			this.modifyClick(row)
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		deleteList () {
			if (this.ids.length === 0) {
				this.$message.error('请至少勾选一条线路！')
			} else {
				this.$confirm('是否确认删除', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					let list = []
					this.ids.forEach(item => {
						list.push(item.lineid)
					})
					var params = {
						lineids: list
					}
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIVShop}/line/delete`,
						data: params
					}).then(res => {
						if (res.resultFlag) {
							this.tableSelectUtils.clear()
							this.$message.success('删除成功')
							this.tableReload()
						} else {
							this.$message.error(res.message)
						}
					})
				})
			}
		},
		getTableDataHandle (data) {
			this.tableSelectUtils.clear()
			this.tableData = data.list
			this.total = data.count
		},
		getParamsData (data) {
			this.page.number = data.page
			this.page.size = data.size
			this.linecode = data.linecode
			this.linename = data.linename
			this.platenumber = data.platenumber
		},
		modifyClick (data) {
			this.ruleForm = JSON.parse(JSON.stringify(data))
			this.addModal = true
		},
		addClick () {
			this.ruleForm = {
				lineid: '',
				linecode: '',
				linename: '',
				platenumber: '',
				carmodel: '',
				carload: '',
				driver: ''
			}
			this.addModal = true
		},
		deleteClick (data) {
			this.$confirm('是否确认删除', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				var params = {
					lineids: [data.lineid]
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/line/delete`,
					data: params
				}).then(res => {
					if (res.resultFlag) {
						this.$message.success('删除成功')
						this.tableReload()
					} else {
						this.$message.error(res.message)
					}
				})
			}).catch(() => {})
		},
		tableReload () {
			let params = {
				linecode: this.linecode,
				linename: this.linename,
				platenumber: this.platenumber,
				page: this.page.number,
				size: this.page.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/line/list`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
				})
				this.total = res.recordCount
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.route-body{
	display: flex;
	min-width :1000px;
	width :100%;
	flex-direction: column;
	height :100%;
	overflow-y :auto;
	padding-bottom :50px;
	border-radius :0px 0px 10px 10px;

	.main-table-box {
		flex: 1
		padding-bottom 10px
		overflow-y: auto;
	}
	.btn-route-box{
		width :90%;
		padding :15px;
		text-align :left
	}
}
.input-box{
	width:200px;
}

.no-star >>> .el-form-item__label::before{
	display :none
}


</style>
<style lang="stylus">
.route-body {
	.cell{
		padding :0 !important
	}
	.el-dialog__footer{
		text-align :center
	}
	.dialog-title {
		text-align: left
		.el-dialog__title {
			padding-left 10px
			border-left 5px solid var(--fx-primary-color)
		}
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}
}
</style>
